<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "encounter"
};
</script>

<style lang="scss"></style>
